import { CampaignSummary } from './campaign-summary'
import { FkuConstraint } from './fku-constraint'

export class CampaignConstraint {
  constructor(
    private summary: CampaignSummary
    ) {
  }

  get allFkuConstraints(): FkuConstraint[] {
    return this.summary.allFkuSummaries.map((fkuSummary) => {
      return new FkuConstraint(fkuSummary)
    })
  }

  get isValid(): boolean {
    return this.campaignIsValid && this.allFkuRulesAreValid
  }

  get campaignIsValid(): boolean {
    return this.priceIsValid && this.countIsValid
  }

  get priceIsValid(): boolean {
    return this.summary.remainingPrice >= 0
  }

  get countIsValid(): boolean {
    if (!this.summary.maxCount) {
      // Falsy value is considered 'no limit'.
      return true
    }

    return this.summary.totalCount <= this.summary.maxCount
  }

  get allFkuRulesAreValid(): boolean {
    return this.allFkuConstraints.every(constraint => constraint.isValid)
  }
}
